/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import * as yup from 'yup'

/**
 * Add the strictEmail method to the yup.string() prototype
 */
declare module 'yup' {
  interface StringSchema {
    strictEmail(message?: string): StringSchema
    phone(message?: string): StringSchema
  }
}

/**
 * Add the strictEmail method to the yup.string() prototype. The basic email method allows for emails like 'test@test'
 * which is not a valid email in the public domain. This method will only allow emails with a valid domain.
 */
yup.addMethod(yup.string, 'strictEmail', function (this: yup.StringSchema, message: string = 'Invalid email format') {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return this.test('strictEmail', message, (value) => {
    return typeof value === 'string' && regex.test(value)
  })
})

/**
 * Add the phone method to the yup.string() prototype. This method will only allow phone numbers with a valid country
 * code.
 */
yup.addMethod(yup.string, 'phone', function (this: yup.StringSchema, message: string = 'Invalid phone number') {
  const regex = /^[]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/
  return this.test('phone', message, (value) => {
    return value === null || value === undefined || value.trim() === '' || regex.test(value)
  })
})

export default yup
